const PropertyMarketFitCard = ({ marketFit }) => {
  if (!marketFit?.available) {
    return (
      <section className="property-detail-section property-detail-section--muted" aria-label="Market fit">
        <h2 className="property-detail-section__title">Market fit</h2>
        <p className="property-detail-empty">Market fit insights coming soon.</p>
      </section>
    );
  }

  return (
    <section className="property-detail-section" aria-label="Market fit">
      <h2 className="property-detail-section__title">Market fit</h2>
      {marketFit.score != null ? (
        <p className="property-detail-market-fit__score">Score: {marketFit.score}</p>
      ) : null}
      {marketFit.valueSignal ? <p>{marketFit.valueSignal}</p> : null}
      {marketFit.rentalAppeal ? <p>Rental appeal: {marketFit.rentalAppeal}</p> : null}
      {marketFit.investorNotes ? <p>{marketFit.investorNotes}</p> : null}
      {marketFit.watchItems?.length ? (
        <ul>
          {marketFit.watchItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : null}
      {marketFit.riskNotes?.length ? (
        <ul>
          {marketFit.riskNotes.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
};

export default PropertyMarketFitCard;
